var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIntroArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 56.2401L49.9492 90.8496L89.8984 56.2401",
    stroke: "#DDDDDD",
    strokeWidth: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 32.6073L49.9492 67.2168L89.8984 32.6073",
    stroke: "#DDDDDD",
    strokeOpacity: 0.5,
    strokeWidth: 9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.9999L49.9492 43.6094L89.8984 8.99991",
    stroke: "#DDDDDD",
    strokeOpacity: 0.2,
    strokeWidth: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIntroArrowDown);
export default __webpack_public_path__ + "static/media/ic-intro-arrow-down.213fc36c1694150d0fb4dd1a5219ab94.svg";
export { ForwardRef as ReactComponent };